import { render, staticRenderFns } from "./AppRating.vue?vue&type=template&id=42759c39"
import script from "./AppRating.vue?vue&type=script&lang=js"
export * from "./AppRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/rouvenpajewski/Documents/Projekte/kuipers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42759c39')) {
      api.createRecord('42759c39', component.options)
    } else {
      api.reload('42759c39', component.options)
    }
    module.hot.accept("./AppRating.vue?vue&type=template&id=42759c39", function () {
      api.rerender('42759c39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/vue/AppRating.vue"
export default component.exports